import BaseService from "@/boot/BaseService";
class EstadoService extends BaseService {
  constructor() {
    super(null, "/estado");
  }
  async index() {
    return await this.get("/");
  }
  async flow() {
    return await this.get("/flow");
  }
}

export default new EstadoService();
